<ng-template #content>
  <tidy-wrapper
    (contentHeight)="contentHeight = $event"
    [class]="windowService?.isDesktopRes ? 'full-width-desktop-padding-pro-settings' : ''">
    <form [formGroup]="form">
      <tidy-desktop-header>
        <div class="wrappable-container">
          <ion-img
            [src]="'assets/svg/arrow-back-black.svg'"
            class="desktop-back-icon"
            (click)="goBack()" />
          <tidy-text
            [title]="'Pro Settings'" />
        </div>
        <div class="non-wrappable-right-aligned-container">
          <tidy-image
            [src]="'assets/img/download_csv.svg'"
            (action)="exportCSV()"
            class="desktop-header-icon secondary-text-icon" />
        </div>
      </tidy-desktop-header>

    <!-- Skeleton table while loading — rows float in with the entrance cascade;
         the real table below then replaces it in place, instantly (skipEntrance). -->
    @if (!loaded) {
      <tidy-table
        [skeletonLoading]="true"
        [columnslabels]="headers" />
    }

    @if (loaded) {
      <tidy-row class="extra-bottom-padding">
        <tidy-three-column-row>
          <tidy-filter
            [label]="'Pro'"
            [showLabels]="true"
            [multiple]="true"
            [items]="proList"
            [initValue]="selectedProIds"
            (optionChange)="onFilterValueChange($event, 'pro')" />
          <tidy-filter
            [label]="'Property'"
            [showLabels]="true"
            [multiple]="true"
            [items]="addressFilter"
            [initValue]="selectedAddressIds"
            (optionChange)="onFilterValueChange($event, 'address')" />
          <tidy-filter
            [label]="'Service Category'"
            [showLabels]="true"
            [multiple]="true"
            [items]="serviceCategoryItems"
            [initValue]="selectedServiceCategoryIds"
            (optionChange)="onFilterValueChange($event, 'serviceCategory')" />
        </tidy-three-column-row>
      </tidy-row>

      @if (errorMessage) {
        <tidy-row>
          <tidy-error-message
            [text]="errorMessage" />
        </tidy-row>
      }
      <ion-card class="form-card">
        <ion-row>
          <ion-col>
            <tidy-row>
              <tidy-text
                [header]="'Select Field(s) to Edit'" />
            </tidy-row>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="settings-col" size="12" size-lg="3">
            <tidy-input
              class="settings-input"
              formControlName="serviceName"
              [form]="form.controls.serviceName"
              [label]="'Edit Service Name for Pro'"
              [icon]="'assets/svg/create.svg'" />
          </ion-col>
          <ion-col class="settings-col" size="12" size-lg="3">
            <tidy-input
              class="settings-input"
              formControlName="defaultRate"
              [form]="form.controls.defaultRate"
              [label]="'Edit Default Rate'"
              [icon]="'assets/svg/cash.svg'"
              [mask]="'currencyMask'" />
          </ion-col>
          <ion-col class="settings-col" size="12" size-lg="3">
            <tidy-input
              class="settings-input"
              formControlName="autopayLimit"
              [form]="form.controls.autopayLimit"
              [label]="'Edit Autopay Limit'"
              [icon]="'assets/svg/cash.svg'"
              [mask]="'currencyMask'" />
          </ion-col>
          <ion-col class="settings-col" size="12" size-lg="3">
            <tidy-button
              [text]="'Update Selected'"
              [action]="boundSaveSettings"
              [smallBody]="true"
              [disabled]="selectedRowsIds.length === 0"
              class="primary save-pro-settings" />
          </ion-col>
        </ion-row>
      </ion-card>
      @if (form.controls.serviceName.value) {
        <tidy-alert>
          <tidy-row>
            <tidy-text
              [helper]="'This changes how services appear to pros.'" />
            <tidy-text
              [helper]="'Customize your view'"
              (action)="goToServiceRename()"
              class="link" />
          </tidy-row>
        </tidy-alert>
      }
      @if (rows?.length > 0) {
        <tidy-row [style.display]="didLoadTable ? 'block' : 'none'">
          <tidy-card class="no-padding">
            <tidy-table
              #tidyTable
              [dataSource]="shownRows"
              [displayedColumns]="headers"
              [columnslabels]="headers"
              [rowsToShow]="25"
              (sortChange)="sortChanged($event)"
              (selectedRowsChange)="selectedRowsChange($event)"
              (unselectedRowsChange)="unselectedRowsChange($event)"
              (pageChange)="pageChange($event)"
              [infiniteScroll]="true"
              [totalRows]="totalRows"
              [skipEntrance]="true"
              [blockSorting]="true" />
          </tidy-card>
        </tidy-row>
      }
      @if (rows?.length == 0) {
        <tidy-divider class="divider-margin" />
        <tidy-row [align]="'center'">
          <tidy-text
            [body]="'You haven\'t added any private pros yet.'" />
        </tidy-row>
      }
      @if (!didLoadTable) {
        <tidy-card style="margin-top: 1.5rem; padding: 0px; height: 1000px; padding: 0px;">
          <ion-skeleton-text animated style="width: 100%; height: 1000px" />
        </tidy-card>
      }
    }
    </form>

</tidy-wrapper>
</ng-template>

<app-scroll-wrapper
  [isfullWidthContent]="true"
  [templateContent]="content"
  [desktopWidthContent]="desktopWidthContent" />